import React from 'react';
import '../css/styles.css';
import whoweare from "../img/who_we_are.jpg";
import {Link} from 'react-router-dom';


export default function WhoWeAre() {
  return (
    <>
      <section className="about-section">
        <div className="container">
            <div className="row clearfix">
            <div className="content-column col-md-1 col-sm-12 col-xs-12">&nbsp; </div>
                  <div className="content-column col-md-5 col-sm-12 col-xs-12">
                    <div className="inner-column">
                        <div className="sec-title">
                          <div className="title">Who We Are</div>
                            <h3>About Shree Sidhdhi Vinayak Engineering</h3>
                          </div>
                          <div className="text">Welcome to Shree Sidhdhi Vinayak Engineering.Shree Sidhdhi Vinayak Engineering is delightfully serving you for all your laser cutting services & metal fabrication work. Our team of cutting professionals is devoted to providing the highest levels of sales, production & customer support.</div>
                          <span><Link className="theme-btn btn-style-three" to="/aboutus">Read More</Link></span>
                      </div>
                  </div>
                  
                  <div className="image-column col-md-4 col-sm-12 col-xs-12">
                    <div className="inner-column " data-wow-delay="0ms" data-wow-duration="1500ms">
                        <div className="image">
                            <img src={whoweare} alt="" />
                          </div>
                      </div>
                  </div>
                  <div className="content-column col-md-2 col-sm-12 col-xs-12">&nbsp; </div>
                  
            </div>

        </div>
      </section>
    </>
  )
}
